var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-column align-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('h1', {
    staticClass: "text-h2 primary--text font-weight-bold"
  }, [_vm._v("Library Cards")]), _c('v-card', {
    staticClass: "mt-12",
    attrs: {
      "max-width": "140ch"
    }
  }, [_c('img', {
    staticClass: "d-block my-8 mx-auto",
    attrs: {
      "src": "https://media.eipl.org/site/images/services/librarycard.jpg"
    }
  }), _c('v-card-title', [_c('h2', {
    staticClass: "text-h6 primary--text font-weight-bold"
  }, [_vm._v(" Applying For a Library Card ")])]), _c('v-card-text', {
    staticClass: "black--text text-body-1 text-left py-8"
  }, [_c('p', {
    staticClass: "text-left"
  }, [_vm._v(" At the Circulation Center you may apply for a new card, replace a lost one, or update your current card. ")]), _c('p', [_vm._v(" Library cards are free of charge to all residents and taxpayers of East Islip, Islip Terrace and Great River. ")]), _c('p', [_vm._v(" You will need to fill out an application and provide two (2) forms of valid identification, such as: a driver's license car registration checkbook current utility bill with your name and mailing address. ")]), _c('p', [_vm._v(" Children from birth to grade 6 are eligible for their own library cards with the signature of a parent or guardian. "), _c('br'), _vm._v(" Teens from grade 7 to 17 years of age can apply for their own card, but still require parental permission for video and DVD privileges and unrestricted Internet access. ")])])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }